const categoryListingBase = {
  categoriesQueryErrorText1: "Ocurrió un error al cargar las categorías, asegúrese de tener conexión a internet o contacte a Jules en",
  categoriesQueryErrorText2: "Ocurrió un error al cargar las categorías, contacte a Jules en",
  categoriesQueryErrorText3: "para asistencia.",
  categoriesQueryErrorText4: "Volver",
  categoriesQueryErrorText5: "Intentar de nuevo",
};

export default categoryListingBase; 